<template>
  <v-container style="max-width: 90%;">
    <v-select :items="teamOptions" v-model="defaultSelected" label="Roster">
    </v-select>
    <v-row>
      <v-col md="6" cols="12" v-if="selectedRoster">
        <v-card
          v-for="player of sortedRoster.players"
          :key="player.player_id"
          class="mx-auto mb-2"
          outlined
        >
          <v-card-title>
            <div
              style="display: flex; width: 100%; justify-content: space-between;"
            >
              <div>{{ player.full_name }}</div>
              <v-checkbox
                @change="setSelectedKeeper($event, player)"
                style="margin-top: 0;"
                v-model="player.isSelected"
              ></v-checkbox>
            </div>
          </v-card-title>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-3"
                >ADP - {{ player.adp ? player.adp : "--" }}</v-list-item-title
              >
              <v-list-item-title class="headline mb-1"
                >Points(PPR)
                {{
                  player.fantasyPoints ? player.fantasyPoints : "--"
                }}</v-list-item-title
              >
              <div class="overline">POSITIONS</div>
              <v-list-item-subtitle>{{
                player.fantasy_positions.join(", ")
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <div
              v-if="player.adp"
              style="display: flex; flex-direction: column; justify-content: center; align-items: center"
            >
              <div v-if="['md', 'lg', 'xl'].includes($vuetify.breakpoint.name)">KEEPER VALUE</div>
              <v-rating
                v-if="['md', 'lg', 'xl'].includes($vuetify.breakpoint.name)"
                v-model="player.valueRating"
                background-color="green lighten-3"
                color="green"
                small
                :readonly="true"
              ></v-rating>
            </div>
            <v-list-item-avatar size="80" color="grey">
              <h1>R.{{ player.keeperRound }}</h1>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col md="6" sm="12">
        <v-row>
          <v-col md="6" cols="12" v-if="selectedRoster">
            <v-card class="mx-auto mb-2" outlined>
              <v-card-title>BEST VALUE</v-card-title>
              <v-list-item three-line>
                <v-list-item-title>{{
                  bestValue.players[0].full_name
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >{{
                    Math.abs(
                      bestValue.players[0].adpRound -
                        bestValue.players[0].keeperRound
                    )
                  }}
                  Round Difference</v-list-item-subtitle
                >
              </v-list-item>
            </v-card>
          </v-col>
          <v-col md="6" cols="12" v-if="selectedRoster">
            <v-card class="mx-auto mb-2" outlined>
              <v-card-title>BEST ADP</v-card-title>
              <v-list-item three-line>
                <v-list-item-title>{{
                  bestADP.players[0].full_name
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >Round {{ bestADP.players[0].adpRound }} Pick as of last data
                  pull</v-list-item-subtitle
                >
              </v-list-item>
            </v-card>
          </v-col>
          <v-col md="6" cols="12" v-if="selectedRoster">
            <v-card class="mx-auto mb-2" outlined>
              <v-card-title>HIGHEST POINT OUTPUT</v-card-title>
              <v-list-item three-line>
                <v-list-item-title>{{
                  mostPoints.players[0].full_name
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >Projected {{ mostPoints.players[0].fantasyPoints }} in full
                  PPR</v-list-item-subtitle
                >
              </v-list-item>
            </v-card>
          </v-col>
          <v-col md="6" cols="12" v-if="selectedRoster">
            <v-radio-group v-model="sortBy" column>
              <v-radio
                label="Sort By Round"
                color="green lighten-3"
                value="round"
              ></v-radio>
              <v-radio
                label="Sort By Value"
                color="green lighten-3"
                value="value"
              ></v-radio>
              <v-radio
                label="Sort By ADP"
                color="green lighten-3"
                value="adp"
              ></v-radio>
              <v-radio
                label="Sort By Points"
                color="green lighten-3"
                value="points"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col md="12" v-if="Object.entries(guessedKeepers).length">
            <v-card md="12" class="mx-auto" outlined>
              <v-list>
                <v-subheader>PICKS</v-subheader>
                <v-list disabled>
                  <v-list-item-group color="primary">
                    <v-list-item
                      v-for="selection of orderedDraftValues"
                      :key="selection.owner_id"
                    >
                      <v-list-item-content>
                        <!-- {{selection}} -->
                        <v-list-item-title
                          v-text="guessedKeepers[selection.owner_id].userName"
                        ></v-list-item-title>
                        <div
                          class="headline"
                          v-if="guessedKeepers[selection.owner_id].player"
                        >
                          {{
                            guessedKeepers[selection.owner_id].player.full_name
                          }}
                          - Round
                          {{
                            guessedKeepers[selection.owner_id].player
                              .keeperRound
                          }}
                        </div>
                        <div v-else>
                          ------
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";

import playerData from "../mixins/playerData";

export default Vue.extend({
  name: "GeniePage",

  data: () => ({
    svcBase: "https://api.sleeper.app/v1/",
    leagueID: "507587931844788224",
    resultContainer: {},
    playerData: {},
    userData: {},
    adpData: {},
    teamOptions: [],
    rosterIds: [],
    rosters: {},
    guessedKeepers: {},
    selectedRoster: null,
    defaultSelected: null,
    teamsList: [],
    sortBy: "round"
  }),
  mounted() {
    this.playerData = playerData.getPlayerData();
    this.adpData = playerData.getADPData();
    this.userData = playerData.getUserData();
    
    // this.parseRawData();  //dump network call from fantasydata into rawData.json, then run this and copy the console log.
    // this.updateKeeperPicks(); //call this to update QB Keeper slots

    axios.get(`${this.svcBase}league/${this.leagueID}/rosters`).then(result => {
      this.resultContainer = result.data;

      result.data.forEach(roster => {
        const id = roster.owner_id;
        const playerList = [];
        this.teamOptions.push({
          text: this.userData[roster.owner_id].user_name,
          value: roster.owner_id
        });

        this.guessedKeepers[roster.owner_id] = {
          userName: this.userData[roster.owner_id].user_name,
          order: this.userData[roster.owner_id].draft_order,
          player: null
        };

        this.teamsList.push(this.userData[roster.owner_id]);

        roster.players.forEach(player => {
          const tempPlayer = this.playerData[player];
          const adpPlayer = this.adpData[tempPlayer.fantasy_data_id];
          if (adpPlayer) {
            const ADPRound = Math.ceil(adpPlayer.AverageDraftPosition2QB / 12);
            const diff = tempPlayer.keeperRound - ADPRound;
            let valueRating;

            if (diff <= 0) {
              valueRating = 1;
            }

            if (diff >= 1 && diff <= 2) {
              valueRating = 2;
            }

            if (diff >= 3 && diff <= 4) {
              valueRating = 3;
            }

            if (diff >= 5 && diff <= 6) {
              valueRating = 4;
            }

            if (diff >= 7) {
              valueRating = 5;
            }

            tempPlayer.adp = adpPlayer.AverageDraftPosition2QB;
            tempPlayer.adpRound = ADPRound;
            tempPlayer.valueRating = valueRating;
            tempPlayer.fantasyPoints = adpPlayer.FantasyPointsPPR;
          } else {
            tempPlayer.valueRating = -999;
          }

          playerList.push(tempPlayer);
        });

        this.rosterIds.push(id);
        this.rosters[id] = {
          players: playerList.sort((a, b) =>
            a.keeperRound > b.keeperRound ? 1 : -1
          ),
          teamInfo: this.userData[roster.owner_id]
        };
        this.defaultSelected = this.teamOptions[0];
      });
    });
  },
  methods: {
    changeRoster(ev) {
      this.selectedRoster = this.rosters[ev];
    },
    updateKeeperPicks() {
      const qbAdjust = this.playerData;
      for(const key in qbAdjust) {
        const player = qbAdjust[key];
        if(player.position === 'QB' && this.adpData[player.fantasy_data_id]) {
          player.keeperRound = Math.ceil(this.adpData[player.fantasy_data_id].AverageDraftPosition2QB / 12) + 1;
        }
      }
      console.log(JSON.stringify(qbAdjust));
      
    },
    parseRawData() {
      const rawData = playerData.getRawData()["Data"];

      const newVal = rawData.reduce((map, obj) => {
        map[obj.PlayerID] = obj;
        return map;
      }, {});

      console.log(newVal);
    },
    sortWithoutNullPoints(field, ascending = true) {
      return function(a, b) {
        a = a[field];
        b = b[field];
        // equal items sort equally
        if (a === b) {
          return 0;
        }
        // nulls sort after anything else
        else if (!a) {
          return ascending ? -1 : 1;
        } else if (!b) {
          return ascending ? 1 : -1;
        } else if (ascending) {
          return a < b ? -1 : 1;
        }
        // if descending, highest sorts first
        else {
          return a < b ? 1 : -1;
        }
      };
    },
    sortWithoutNullADP(field, ascending = true) {
      return function(a, b) {
        a = a[field];
        b = b[field];
        // equal items sort equally
        if (a === b) {
          return 0;
        }
        // nulls sort after anything else
        else if (!a) {
          return ascending ? 1 : -1;
        } else if (!b) {
          return ascending ? -1 : 1;
        } else if (ascending) {
          return a < b ? -1 : 1;
        }
        // if descending, highest sorts first
        else {
          return a < b ? 1 : -1;
        }
      };
    },
    setSelectedKeeper(ev, player) {
      if (this.guessedKeepers[this.selectedRoster.teamInfo.owner_id].player) {
        this.guessedKeepers[
          this.selectedRoster.teamInfo.owner_id
        ].player.isSelected = false;
        this.guessedKeepers[
          this.selectedRoster.teamInfo.owner_id
        ].player = null;
      }

      if (ev) {
        this.guessedKeepers[
          this.selectedRoster.teamInfo.owner_id
        ].player = player;
      } else {
        this.guessedKeepers[
          this.selectedRoster.teamInfo.owner_id
        ].player = null;
      }
    }
  },
  watch: {
    defaultSelected(newValue) {
      this.selectedRoster = newValue.value
        ? this.rosters[newValue.value]
        : this.rosters[newValue];
      if (this.sortBy === "adp") {
        this.sortedRoster = this.bestADP;
      } else if (this.sortBy === "points") {
        this.sortedRoster = this.mostPoints;
      } else if (this.sortBy === "value") {
        this.sortedRoster = this.bestValue;
      } else {
        this.sortedRoster = this.selectedRoster;
      }
    },
    sortBy(newValue) {
      if (newValue === "adp") {
        this.sortedRoster = this.bestADP;
      } else if (newValue === "points") {
        this.sortedRoster = this.mostPoints;
      } else if (newValue === "value") {
        this.sortedRoster = this.bestValue;
      } else {
        this.sortedRoster = this.selectedRoster;
      }
    }
  },
  computed: {
    bestValue() {
      const cloneRoster = JSON.parse(JSON.stringify(this.selectedRoster));
      cloneRoster.players.sort((a, b) =>
        a.valueRating < b.valueRating ? 1 : -1
      );
      return cloneRoster;
    },
    bestADP() {
      const cloneRoster = JSON.parse(JSON.stringify(this.selectedRoster));
      cloneRoster.players.sort(this.sortWithoutNullADP("adp"));
      return cloneRoster;
    },
    mostPoints() {
      const cloneRoster = JSON.parse(JSON.stringify(this.selectedRoster));
      cloneRoster.players.sort(
        this.sortWithoutNullPoints("fantasyPoints", false)
      );
      return cloneRoster;
    },
    orderedDraftValues() {
      const cloneTeams = JSON.parse(JSON.stringify(this.teamsList));
      cloneTeams.sort((a, b) => (a.draft_order > b.draft_order ? 1 : -1));
      return cloneTeams;
    }
  }
});
</script>
